<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz swój prompt do poprawienia:</label>

              <b-input-group>

                <b-form-textarea v-model="temat" rows=6 size="lg" ref="temat" placeholder="np. napisz mi post na Facebooka, jestem dentystą"></b-form-textarea>
                
              </b-input-group>
 
            </div>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje wynik <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana treść</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;">

              <div v-if="result" v-html="result" class="pb-3 mb-3" style="border-bottom: 1px solid #ddd;"></div>

            </div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  import { languages } from './../../../resources/languages.js';

  export default {
    name: 'AppArticleSEOIdeas',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        result2: "",
        selectedText: '',
        query: "",
        lang: "Polski",
        languages,
        temat: "",
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {

      generateFinish: function() {

        if(!this.temat) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Rola:"+
                    "Jesteś ekspertem od inżynierii promptów (prompt engineering) i optymalizacji komunikacji z modelami językowymi."+
                    "Twoim zadaniem jest przeanalizowanie prompta użytkownika i stworzenie jego lepszej wersji, która:"+
                    "•jest bardziej precyzyjna,"+
                    "•eliminuje niejednoznaczności,"+
                    "•zawiera kontekst (cel użytkownika, styl, ton, format),"+
                    "•pozwala ChatGPT zrozumieć co dokładnie ma zrobić i jak ma to zrobić,"+
                    "•maksymalnie zwiększa jakość odpowiedzi."+
                    
                    " Zasady działania:"+
                    "1.	Zrozum prompt użytkownika."+
                    "Odczytaj jego cel – co chce osiągnąć."+
                    "Zidentyfikuj, czego brakuje (np. kontekstu, roli, stylu, formatu odpowiedzi)."+
                    "2.	Popraw prompt."+
                    "o	Dodaj jasną rolę modelu (np. “Jesteś ekspertem od marketingu…”)."+
                    "o	Doprecyzuj cel użytkownika (“Celem jest napisanie maila promocyjnego dla produktu X…”)."+
                    "o	Dodaj wymagany styl / ton / długość / format odpowiedzi."+
                    "o	Usuń zbędne lub mylące instrukcje."+
                    "o	Zachowaj sens oryginału, ale spraw, by był bardziej inteligentny, strukturalny i wydajny."+
                    "3.	Zwróć dwa warianty:"+
                    "o	Oryginał (od użytkownika)"+
                    "o	Ulepszony prompt (Twoja wersja)"+
                    "4.	Na końcu krótko wyjaśnij, dlaczego ulepszona wersja jest lepsza (np. “Dodałem rolę eksperta, styl storytellingowy i określiłem długość odpowiedzi.”)."+
                    
                    "Format odpowiedzi:"+
                    "Oryginalny prompt:"+
                    "[tu wklej prompt użytkownika]"+
                    
                    "Ulepszony prompt:"+
                    "[tu wklej poprawioną wersję]"+
                    
                    "Dlaczego ta wersja jest lepsza:"+
                    "[krótkie uzasadnienie 2–3 zdania]"+
                    
                    "Oto prompt użytkownika: " + this.temat;

   

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/><br/>');


          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana treść"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {


 
    },
    mounted() {

      if (localStorage.generators_language) {

        this.lang = localStorage.generators_language;

      } else {

        localStorage.generators_language = "Polski"
        this.lang = "Polski"
      }

    },
    watch: {

      lang(data) {

        localStorage.generators_language = data;

      },

    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>